import mediasMixins from 'root/mixins/mediasMixin.js'
import PartialSpinner from 'root/components/partialspinner/partialspinner.vue'
import utilsMixin from 'root/mixins/utilsMixin.js';

export default {
  name: 'product-grid-page',
  mixins: [mediasMixins, utilsMixin],
  components: {PartialSpinner},
  props: ['findciudadesurl', 'breadcrumbs', 'disable-category-name'],
  data () {
    return {
      filtrosOpened: false,
      showPartialSpinner: false
    }
  },

  methods: {
    bindEvents() {
      this.$root.$on('show--spinner--category--page', _.bind(function () {
        this.showPartialSpinner = true
      }, this))
      this.$root.$on('hide--spinner--category--page', _.bind(function () {
        this.showPartialSpinner = false
        this.filtrosOpened = false
      }, this))
    }
  },

  computed: {
    parsedBreadcrumbs: function() {
      return this.isJson(this.breadcrumbs);
    },
    pageTitle() {
      return this.disableCategoryName != 'true' && this.parsedBreadcrumbs.length > 1 && _.get(_.last(this.parsedBreadcrumbs), "name")
    }
  },

  mounted: function () {
  },

  watch: {
  },
  
  created() {
    this.bindEvents()
    window.onpopstate = function (event) {
      location.reload()
    }
  }
}



// WEBPACK FOOTER //
// ./web/webroot/_ui/responsive/common/js/src/components/productgridpage/productgridpage.js